<template>
  <div class="i-main-content">

    <!--面包屑-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Container List</el-breadcrumb-item>
    </el-breadcrumb>

    <!--搜索-->
    <search-wrapper>
      <tree-select :datas="treeSelect.data" v-model="treeSelect.visible" class="block"
        :defaultCheckedRows="treeSelect.checked" @check="treeSelectCheck" :panel-width="treeSelect.width"
        :props="treeSelect.props" check-strictly expand-first>
        <el-input v-model="treeSelect.text" placeholder="Select Enterprise" slot="active" @focus="treeSelect.visible=true"></el-input>
      </tree-select>
      <!--查询字段选项-->
      <el-select v-model="searchFieldName" placeholder="Query Type" class="block">
        <el-option
          v-for="item in searchFieldOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--查询字段内容-->
      <el-input v-model="searchText" placeholder="Query Text" prefix-icon="el-icon-search" class="block" clearable></el-input>
      <el-button @click="queryHandle" type="primary" :disabled="tableLoading">Query</el-button>
      <space></space>
      <el-button @click="addHandle" type="" v-if="userId == '1'">Add</el-button>
      <el-button @click="deleteHandle" type="" :loading="deleteButtonLoading">Delete</el-button>
    </search-wrapper>

    <!--表格-->
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" tyle="width: 100%"
      @selection-change="val => multipleSelection=val" v-loading="tableLoading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="GoupId" prop="groupId" width="120"></el-table-column>
      <el-table-column label="Date" width="120">
        <template slot-scope="scope">{{ scope.row.date }}</template>
      </el-table-column>
      <el-table-column label="Name" width="250">
        <div class="i-link" slot-scope="scope" @click.stop="rowClick(scope.row)">{{ scope.row.name }}</div>
      </el-table-column>
      <el-table-column label="Contact" prop="contactName" width="120"></el-table-column>
      <el-table-column label="Tel" prop="number" width="120"></el-table-column>
      <el-table-column label="Email" prop="enauk" width="120"></el-table-column>
      <el-table-column prop="address" label="Address" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-pagination class="i-main-pager imt-2" background layout="total, prev, pager, next, jumper" :total="tableData.length"></el-pagination>

    <!--Dialog-->
    <el-dialog title="详细信息" :visible.sync="dialogVisible">
      <el-form :model="form" label-position="left" label-width="120px">
        <el-form-item label="Group-ID" >
          <el-input v-model="form.groupId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Name">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Contact" >
          <el-input v-model="form.contactName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Tel">
          <el-input v-model="form.number" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="form.email" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Address">
          <el-input v-model="form.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="okHandle" :loading="dialogOkButtonLoading">确定</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//import {getToken} from '@/common/auth'
import treeSelect from '@/views/mixins/tree-select'
import searchCommon from '@/views/mixins/search-common'
import searchWrapper from '@/components/search-wrapper'
import {deleteFromArray} from '@/common/utils'
import {mapGetters} from 'vuex'
import {Filter, Op} from '@/api/config'
import * as API from '@/api/rule'
import { searchFieldOptions, searchFieldOperation } from './options'

export default {
  name: 'company',
  data() {
      return {
        // Dialog
        // clickedRow: {},
        dialogVisible: false,
        form: {},

        // Search
        searchFieldName: '', // 查找字段名
        searchFieldOptions, // 查找备选项
        searchFieldOperation, // 查找字段对应操作
        searchText: '',
        searchCompany: '',

        // Table
        tableData: [{
          groupId: '',
          contactName: '',
          number: '',
          email: '',
          date: '2016-05-03',
          name: 'Group A Name',
          address: 'Group A Address',
          holdId: ['1']
        }, {
          groupId: '',
          contactName: '',
          number: '',
          email: '',
          date: '2016-05-02',
          name: 'Group B Name',
          address: 'Group B Address',
          holdId: ['1', '2']
        }, {
          groupId: '',
          contactName: '',
          number: '',
          email: '',
          date: '2016-05-04',
          name: 'Group C Name',
          address: 'Group C Address',
          holdId: ['1', '3']
        }],

        multipleSelection: [] // 选中行数据
      }
  },
  computed: {
    ...mapGetters([
      'userId'
    ])
  },
  methods: {
    // 表格行点击事件
    rowClick(row) {
      //console.log(this, Object.keys(this.clickedRow), Object.keys(row))

      // Object.keys(row).forEach(item => {
      //   this.$set(this.form, item, row[item])
      // })
      this.form = Object.assign({}, row)
      this.dialogVisible = true
    },


    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 新增事件
    addHandle() {
      // Object.keys(this.form).forEach(item => {
      //   this.form[item] = null
      // })
      this.form = {}
      this.dialogVisible = true
    },

    // 删除事件
    deleteHandle() {
      const targetRows = this.$refs.multipleTable.selection

      if (targetRows.length <= 0) {
        this.$alert('You must select at least one item.', '', {
          type: 'error'
        })
      }

      targetRows.forEach(item => {
        deleteFromArray(this.tableData, row => {
          return row == item
        })
      })
    },

    // 弹出页确认事件
    okHandle() {
      const index = this.tableData.findIndex(item => {
        return item.name == this.form.name
      })

      if (!~index) {
        // Add
        this.tableData.push(this.form)
      } else {
        // Modify
        this.$set(this.tableData, index, this.form)
      }

      this.dialogVisible = false
    },

    // 查询事件
    queryHandle() {
      const filters = []
      this.searchText.length > 0
        && (filters.push(new Filter(this.searchFieldName, this.searchText, Op.Equals)))
    },

    // 反选表格
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
  },
  components: {
    searchWrapper
  },
  mixins: [treeSelect, searchCommon]
}
</script>

<style lang="scss" scoped>
.i-main-content {
  & .el-form {
    width: 460px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rule/rule.vue